import SectionDestinations from '../../../containers/LandingPage/SectionDestinations';
import { withBaseComponent } from '../hoc/withBaseComponent';

const StoryblokDestinationsPreset = () => {
  return <SectionDestinations />;
};

export default withBaseComponent(StoryblokDestinationsPreset);
